export const SUBSCRIPTION_GUIDE_LAND_FROM = {
  MIRROR_HEADER_BANNER: 'mirror_header_banner',
  REGION_FILTER_BANNER: 'region_filter_banner',
  GENDER_FILTER_BANNER: 'gender_filter_banner',
  SHOP: 'shop',
  SETTING_SUBSCRIPTION: 'setting_subscription',
  ITEM_INVENTORY: 'item_inventory',
} as const;

export type SubscriptionGuideLandFrom =
  (typeof SUBSCRIPTION_GUIDE_LAND_FROM)[keyof typeof SUBSCRIPTION_GUIDE_LAND_FROM];

export const INITIAL_FEATURE = {
  NONE: 'none',
  UNLIMITED_FILTER_DISCOUNT: 'unlimited_filter_discount',
  REGION_CHOICE: 'region_choice',
  CAMERA_ON: 'camera_on',
  AGE_PREFER: 'age_prefer',
  AZAR_PICK_DISCOUNT: 'azar_pick_discount',
  REMOVE_AD: 'remove_ad',
} as const;

export type InitialFeature = (typeof INITIAL_FEATURE)[keyof typeof INITIAL_FEATURE];
